export default __webpack_public_path__ + "static/media/article.46118fde.svg";